/**
 * axios二次封装
 */
import axios from 'axios';
import { Loading, Message } from 'element-ui';
// 创建axios 实例对象,添加全局配置
const service = axios.create({
  baseURL: null,
});
// 请求拦截
service.interceptors.request.use((req) => {
  const headers = req.headers;
  const token = JSON.parse(localStorage.getItem('user'))?.token || '';
  if (token != '') headers.Authorization = token;
  
  // 为特定请求显示loading（除了验证码请求）
  if (req.url !== '/captcha/captchaImage') {
    req.loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  
  return req;
});
// 响应拦截
service.interceptors.response.use((res) => {
  // 关闭loading
  if (res.config.loadingInstance) {
    res.config.loadingInstance.close();
  }
  return res;
}, (error) => {
  // 错误处理时也要关闭loading
  if (error.config && error.config.loadingInstance) {
    error.config.loadingInstance.close();
  }
  return Promise.reject(error);
});
const request = {};

// init->根据传参初始化修改config的配置(局部mock 和全局mock)并将配置好的service返回
request.init = function (option) {
  // if (option) {
  //   service.headers = option.header;
  //   console.log(service.headers);
  // }
  service.defaults.baseURL = process.env.VUE_APP_BASE_API;
  return service;
};
request.get = function (url, data, option) {
  return request.init(option).get(url, {
    //data数据要给到axios Get请求的 params
    params: data,
    ...option,
  });
};
request.post = function (url, data, option) {
  console.log('option', option);
  return request.init(option).post(url, data, option);
};
request.put = function (url, data, option) {
  return request.init(option).put(url, data, option);
};
request.delete = function (url, data, option) {
  return request.init(option).delete(url, {
    data,
    ...option,
  });
};
request.getByPython = function (url, data, option) {
  return request.init(option).get(url, {
    params: data,
  });
};
export default request;